import { EditNoteOutlined, InfoTwoTone, Print } from '@mui/icons-material';
import { Box, CircularProgress, IconButton, Stack, Tooltip } from '@mui/material';
import { H6, Tiny } from 'components/Typography';
import FormatDate from 'utils/formatDate';

const columnShape = [
    {
        Header: 'Invoice Number',
        accessor: 'invoiceNumber',
        disableSortBy: true,
    },
    {
        Header: 'Name',
        accessor: 'nickName',
    },
    {
        Header: 'Email',
        accessor: 'email',
    },
    {
        Header: 'QR Code',
        accessor: 'qrCode',
        disableSortBy: true,
    },
    {
        Header: 'Status',
        accessor: 'registrationDate',
        Cell: ({ value }) => {

            return (
                <Stack direction="column" spacing={1} alignItems="left">
                    <H6 color="text.primary">{value ? 'Re-Registered' : 'Not Yet'}</H6>
                    {value && (
                        <Tiny color="text.disabled">{FormatDate(value, 'dd MMMM yyyy HH:mm')}</Tiny>
                    )}
                </Stack>
            );
        },
    },
    {
        Header: 'Action',
        accessor: 'id',
        disableSortBy: true,
        Cell: ({ row, handlePrint, handleChangeName, handleInfo, isPrinting }) => {
            const isRegistaror = ['registrator'].includes(
                localStorage.getItem('role'),
            );
            return (
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                    }}
                >
                    <Tooltip title="Print Badge">
                        <IconButton
                            onClick={() => handlePrint(row.original)}
                            disabled={isPrinting}
                            sx={{
                                color: 'text.disabled',
                                fontSize: 18,
                                display: isRegistaror ? 'none' : 'block',
                            }}
                        >
                            {isPrinting ? (
                                <CircularProgress size={18} color="inherit" />
                            ) : (
                                <Print />
                            )}
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Change Name">
                        <IconButton
                            onClick={() => handleChangeName(row.original)}
                            sx={{
                                color: 'text.disabled',
                                fontSize: 18,
                            }}
                        >
                            <EditNoteOutlined />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Participant Information">
                        <IconButton
                            onClick={() => handleInfo(row.original)}
                            sx={{
                                color: 'text.disabled',
                                fontSize: 18,
                            }}
                        >
                            <InfoTwoTone />
                        </IconButton>
                    </Tooltip>
                </Box>
            );
        },
    },
];
export default columnShape;
